/* Renders a compact design preview in each collection card via the ported engine. */
(function () {
  function boot() {
    var cards = document.querySelectorAll('[data-tmd-card]');
    if (!cards.length) return;
    if (!window.TMDesigner) { setTimeout(boot, 60); return; }
    var D = window.TMDesigner;
    try { D.injectCSS(document.documentElement); } catch (e) {}
    cards.forEach(function (c) {
      if (c.dataset.tmdDone) return;
      var tpl = D.TPL[c.getAttribute('data-tpl')];
      if (!tpl) return;
      try {
        var cfg = D.cfgOfTpl(tpl, 'osd');
        var mode = c.getAttribute('data-tmd-mode') || 'one';
        if (mode === 'auto') {
          // Full product preview: a pair for couple designs, a single for single tees.
          var kind = tpl.kind === 'couple' ? 'pair' : 'one';
          c.innerHTML = D.scene(kind, cfg, {});
        } else {
          var o = { side: c.getAttribute('data-side') || 'a' };
          var face = c.getAttribute('data-face'); if (face) o.face = face;
          c.innerHTML = D.scene('one', cfg, o);
        }
        c.dataset.tmdDone = '1';
        var fb = c.parentNode && c.parentNode.querySelector('[data-tmd-cardfallback]');
        if (fb) fb.style.display = 'none';
        // Optional: fill a description line from the design's tagline.
        var line = c.closest('a, .tm-pcard, .tm-door') ;
        var lineEl = line && line.querySelector('[data-tmd-line]');
        if (lineEl && !lineEl.textContent.trim()) lineEl.textContent = tpl.line || '';
      } catch (e) {}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
